import { useSelector } from "react-redux";

export const useAuthorizationCheck = (rightId, roleId = 0) => {
  const { user } = useSelector((state) => state.user);

  if (user?.userId && user !== "undefined") {
    if (roleId === 0) {
      roleId = user?.role?.id;
    }

    if (roleId === 4) {
      if (
        user?.agentHierarchy?.length > 0 &&
        user?.agentHierarchy?.filter(
          (x) => x.agentId === user.agentViewingId
        )[0].agentInfo.status === "V"
      ) {
        roleId = 7;
      }
    }

    let IsAuthorized = user.roleRightMaster
      .filter((x) => x.roleId === roleId)
      .some((x) => x.rightId === rightId);

    return IsAuthorized;
  } else {
    return false;
  }
};
